import { render, staticRenderFns } from "./BlockImageOversized.vue?vue&type=template&id=b6adff26"
import script from "./BlockImageOversized.vue?vue&type=script&lang=js"
export * from "./BlockImageOversized.vue?vue&type=script&lang=js"
import style0 from "./BlockImageOversized.vue?vue&type=style&index=0&id=b6adff26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports